import uiRouter from 'angular-ui-router';
import './reportingRoles.scss';
var module = angular.module('RoleHeirarchy', [
    uiRouter
   
]);

import roleHierarchyTpl from './views/roleHierarchy.html';
import roleHierarchyCtrl from './controllers/roleHierarchyController';
import './reportingRoles.scss';
import userHierarchyTpl from './views/userHierarchy.html';
import userHierarchyCtrl from './controllers/userHierarchyController';
import roleSettingsTpl from './views/roleSettings.html';
import roleSettingsCtrl from './controllers/roleSettingsController';
import userSettingsTpl from './views/userSettings.html';
import userSettingsCtrl from './controllers/userSettingsController';

import _ from "underscore"

module.constant('ROLEHIERARCHYCONSTANT', {
  API_GET_ROLE_HIERARCHY : "/v0/hierarchy/build-role-hierarchy/",
  //API_SET_PRIVILEGE_DEFAULT:"/v0/privilege/set-selected-privilege-default",
  //API_UPDATE_PRIVILEGE :"/v0/privilege/update-features"
})


module.config(function($stateProvider, $locationProvider) {
    "ngInject";

    $stateProvider
        .state('roleHeirarchy', {
            parent: 'app',
            url: '/role-heirarchy',
            views: {
                '@': {
                    template: roleHierarchyTpl,
                    controller: roleHierarchyCtrl,
                    controllerAs: 'roleHeirarchy'
                }   
            }
        })
});

var module = angular.module('UserHeirarchy', [
    uiRouter
   
]);
module.constant('USERHIERARCHYCONSTANT', {
    API_GET_USER_HIERARCHY:"/v0/hierarchy/build-userhierarchy/",
    //API_GET_MODULE_LIST : "/v0/privilege/get-all-modules/",
    //API_CHECK_PRIVILEGE_EXISTS:"/v0/privilege/check-if-privilege-exits",
    //API_SET_PRIVILEGE_DEFAULT:"/v0/privilege/set-selected-privilege-default",
    //API_UPDATE_PRIVILEGE :"/v0/privilege/update-features"
  })
  
  
  module.config(function($stateProvider, $locationProvider) {
      "ngInject";
  
      $stateProvider
          .state('reportingRoles', {
              parent: 'app',
              url: '/user-hierarchy',
              views: {
                  '@': {
                      template: userHierarchyTpl,
                      controller: userHierarchyCtrl,
                      controllerAs: 'reportingRoles'
                  }   
              }
          })
  
      
  
  
   });

   var module = angular.module('RoleSettings', [
    uiRouter
   
]);
module.constant('ROLESETTINGSCONSTANT', {
    API_GET_ALL_ROLES:"/v0/initial-settings/user-console/roles/added/",
    API_GET_ALL_ROLE_MAPPING:"/v0/hierarchy/get-all-reporting-roles-mapping/",
    API_SAVE_ROLE_MAPPING:"/v0//hierarchy/save-role-mapping",
    API_UPDATE_ROLE_MAPPING:"/v0//hierarchy/update-role-mappings",
    API_GET_MAPPED_PARENTS:"/v0/hierarchy/get-mapped-parent-roles",
    //API_GET_USER_HIERARCHY:"/v0/hierarchy/build-userhierarchy/",
    //API_GET_MODULE_LIST : "/v0/privilege/get-all-modules/",
    //API_CHECK_PRIVILEGE_EXISTS:"/v0/privilege/check-if-privilege-exits",
    //API_SET_PRIVILEGE_DEFAULT:"/v0/privilege/set-selected-privilege-default",
    //API_UPDATE_PRIVILEGE :"/v0/privilege/update-features"
  })
  
  
  module.config(function($stateProvider, $locationProvider) {
      "ngInject";
  
      $stateProvider
          .state('roleMapping', {
              parent: 'app',
              url: '/role-mapping',
              views: {
                  '@': {
                      template: roleSettingsTpl,
                      controller: roleSettingsCtrl,
                      controllerAs: 'roleMapping'
                  }   
              }
          })
  
      
  
  
   });
   var module = angular.module('UserSettings', [
    uiRouter
   
]);
module.constant('USERSETTINGSCONSTANT', {
    API_GET_HEAD_ROLES:"/v0/hierarchy/get-head-roles/",
    API_GET_USERCOUNT:"/v0/hierarchy/get-count-of-users",
    API_GET_USERS:"/v0/hierarchy/get-users-with-child",
    API_UPDATE_ROLE_MAPPING:"/v0//hierarchy/update-role-mappings",
    API_GET_MAPPED_PARENTS:"/v0/hierarchy/get-mapped-parent-roles",
    API_GET_SUB_ROLES:"/v0/hierarchy/get-sub-roles",
    API_GET_SUB_USERS:"/v0//hierarchy/get-sub-users",
    API_SAVE_USER_MAPPING:"/v0/hierarchy/save-reporting-roles"
  })
  
  
  module.config(function($stateProvider, $locationProvider) {
      "ngInject";
  
      $stateProvider
          .state('createHierarchy', {
              parent: 'app',
              url: '/user-mapping',
              views: {
                  '@': {
                      template: userSettingsTpl,
                      controller: userSettingsCtrl,
                      controllerAs: 'createHierarchy'
                  }   
              }
          })
   });


// WEBPACK FOOTER //
// ./src/app/reporting-roles/reportingRolesModule.js